module.exports = __webpack_public_path__ + "img/75639.03246841.svg";